module.exports = __webpack_public_path__ + "img/tushi1.db3acfb5.jpg";